import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterResource} from "../../helpers/filters";
import {trackEventByUrl} from "../../helpers/events";

interface Data {
    nodeById: {
        entityLabel: string;
        fieldLink: Array<{
            uri: string;
        }>;
        fieldImageMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: number;
                    height: number;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
    }
}

class InlineDealerQuery extends Query<Data, {id: string}> {}

const GET_DEALER = gql`
query dealerQuery($id: String!) {
  nodeById(id: $id) {
    ... on NodeContentDealer {
      entityLabel
      fieldLink {
        uri
      }
      fieldImageMedia {
          entity {
            ... on MediaImage {
              fieldMediaImage {
                width
                height
                url
                targetId
                alt
                title
              }
            }
        }
      }
    }
  }
}

`;

const getLogo = node => {
    let logo = null;
    if (node.fieldImageMedia && node.fieldImageMedia.entity && node.fieldImageMedia.entity.fieldMediaImage && node.fieldImageMedia.entity.fieldMediaImage.url) {
        logo = (<img src={filterResource(node.fieldImageMedia.entity.fieldMediaImage.url)} alt={node.fieldImageMedia.entity.fieldMediaImage.alt}/>);
    }

    // Wrap with Anchor if Link is added
    if (node.fieldLink && node.fieldLink.uri) {
        return (
            <a href={node.fieldLink.uri} target="_blank" rel="noopener noreferrer" onClick={() => trackEventByUrl(node.fieldLink.uri, node.fieldImageMedia.entity.fieldMediaImage.alt)}>
                {logo}
            </a>
        )
    }

    return logo;
};

const InlineDealer = ({id, count}) => (
    <InlineDealerQuery asyncMode query={GET_DEALER} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error || !data.nodeById) return <div>{error || null}</div>;

            const node = data.nodeById;

            return (
                <div className="inlineDealerItem">
                    <div className="inlineDealerItem__logo">
                        {getLogo(node)}
                    </div>
                    <div className="inlineDealerItem__count">
                    {count}
                    </div>
                </div>
            );
        }}
    </InlineDealerQuery>
);

InlineDealer.propTypes = {
    id: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired
};

export default InlineDealer;



// WEBPACK FOOTER //
// ./frontend/components/InlineDealer/InlineDealer.jsx